import Vue from 'vue'
import store from '@/store'

/**权限指令**/
Vue.directive('has', {
  bind: function (el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      // el.parentNode.removeChild(el);
      el.style.display = 'none';
    }
  }
});
//权限检查方法
Vue.prototype.$_has = function (value) {
  // 权限列表
  let permissionlist = store.getters.roles;
  for (let item of permissionlist) {
    if (item === value) {
      return true;
    }
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/utils/btnPermission.js